import {APIService} from '@/services/api.service';
import {UserProfile} from '@mobi-components/global-solution';

export async function saveSolutionToMyTrips(
  sessionId: string,
  userId: string,
  profile: UserProfile | null,
  tripName: string,
  autoSave = true,
): Promise<void | null> {
  return APIService.post<void>(
    `session`,
    {profile, trip_name: tripName},
    {
      params: {
        session_id: sessionId,
        user_id: userId,
        auto_saved: autoSave,
      },
    },
  )
    .finally(() => {
      sessionStorage.setItem('trip-saved-time', new Date().valueOf().toString());
    })
    .catch(() => null);
}
